module.exports = __webpack_public_path__ + "img/testem_1.fbd01080.png";